import { Network } from '../services/token.service'

export function humanReadableHash(hash: string, isMobile: boolean): string {
    if (!hash) {
        return 'NO ACCOUNT'
    }
    if (hash.length <= 8) {
        return hash
    }
    if (isMobile) {
        return hash.substr(0, 4) + '...' + hash.substr(-2)
    }
    return hash.substr(0, 5) + '...' + hash.substr(-3)
}

export function humanReadableHashExtended(hash: string, isMobile: boolean): string {
    if (hash.includes('.stark')) return hash
    if (!hash) {
        return 'NO ACCOUNT'
    }
    if (hash.length <= 8) {
        return hash
    }
    if (isMobile) {
        return hash.substr(0, 4) + '...' + hash.substr(-2)
    }
    return hash.substr(0, 7) + '...' + hash.substr(-7)
}

export function hex_to_ascii(str1: string): string {
    var hex = str1
    var str = ''
    for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16))
    }
    return str
}

export function shortenText(text: string, chars: number, isShorten?: boolean) {
    if (!isShorten) return text
    return text.substring(0, chars)
}

export const getWalletAddress = () => {
    return window.getStarknet?.()?.selectedAddress ?? ''
}

export const getNetworkBaseUrl = (network: Network): string => {
    switch (network) {
        case 'mainnet-alpha':
            return 'https://alpha-mainnet.starknet.io'

        case 'goerli-alpha':
            return 'https://alpha4.starknet.io'
        case 'sepolia-alpha':
            return 'https://alpha-sepolia.starknet.io'
        default:
            return 'https://alpha-mainnet.starknet.io'
    }
}
